import {Component, Vue} from "vue-property-decorator";
import OwnerSelector, {Owner} from "@/componentsReusable/OwnerSelector.vue";

export enum BonusCellDisplay{
  HOURS =0,
  BILLABLE =1
}

@Component({
  components: {
    OwnerSelector
  },
  filters: {
    cellDisplay(cellData: any, showBilledAmounts: boolean) {
      if (!cellData) {
        return '';
      } else if (!cellData.workedThisMonth) {
        return showBilledAmounts ? cellData.billedAmount : cellData.hours;
      } else {
        if (showBilledAmounts) {
          return (Vue as any).options.filters.currency(cellData.billedAmount)
        } else {
          return (Vue as any).options.filters.round(cellData.hours)
        }
      }
    }
  }
})
export default class MonthlyBonusReport extends Vue {

  employeeName = 'Select a representative';
  showBilledAmounts = true;
  showHours = false;
  inputParams = {
    nmrEmployeeId: 0,
    year: new Date().getUTCFullYear(),
    month: new Date().getUTCMonth() + 1,
    displayType: BonusCellDisplay.BILLABLE
  };

  onShowBilledAmountsChanged(val: boolean) {
    this.showHours = !val;
    this.inputParams.displayType = val ? BonusCellDisplay.BILLABLE : BonusCellDisplay.HOURS;
  }

  onShowHoursChanged(val: boolean) {
    this.showBilledAmounts = !val;
    this.inputParams.displayType = val ? BonusCellDisplay.HOURS : BonusCellDisplay.BILLABLE;
  }

  get inputParamsValid(): boolean {
    return this.inputParams.nmrEmployeeId !== 0;
  }

  clearInputParams() {
    this.employeeName = 'Select a representative';
    this.inputParams.nmrEmployeeId = 0;
    this.inputParams.displayType = BonusCellDisplay.BILLABLE;
    // the month picker isn't currently governable and I don't want to fix it.
    this.showBilledAmounts = true;
    this.showHours = false;
  }

  monthChanged(date: Date) {
    this.inputParams.month = date.getUTCMonth() + 1;
    this.inputParams.year = date.getUTCFullYear();
  }

  selectEmployee(owner: Owner) {
    this.employeeName = owner.fullName;
    this.inputParams.nmrEmployeeId = owner.id;
  }

  browseToFacility (facilityId: number) {
    window.open("/facilities/" + facilityId, '_blank');
  }

  getClass(rowName: string, cell: any) {
    return {
      'worked-only-previous-month': cell && !cell.workedThisMonth,
      'subtotal': rowName === 'Subtotals',
      'owns-facility': cell && cell.workedThisMonth && cell.ownsFacility && !(cell.ownsProvider || cell.coOwnsProvider),
      'owns-provider': cell && cell.workedThisMonth && (cell.ownsProvider || cell.coOwnsProvider) && !cell.ownsFacility,
      'owns-both': cell && cell.workedThisMonth && cell.ownsFacility && (cell.ownsProvider || cell.coOwnsProvider)
    };
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/monthlybonus/MonthlyBonusReport.ts